import useAxios from '@/compositions/useAxios';
import axios from 'axios';
import store from '@/store';

const { fetchData, postData } = useAxios();

export function getBelong(params) {
	return new Promise((resolve, reject) => {
		fetchData(
			'/getBelong',
			params,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function getUserInfo(params) {
	// 개인정보 불러옴
	return new Promise((resolve, reject) => {
		fetchData(
			'/getUserInfo',
			params,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function getEngChecklistPop(params) {
	// 엔지니어 안전점검 체크리스트 팝업 조회
	return new Promise((resolve, reject) => {
		axios
			.get('/v1/getEngChecklistPop', {
				headers: { authorization: store.state.token.access_token },
				params,
			})
			.then((res) => {
				if (res.data?.success) {
					resolve(res.data);
				} else {
					reject(res.data || res.response?.data || res);
				}
			})
			.catch((error) => {
				reject(error.response?.data || error);
			});
	});
}

export function saveEngCheckVanResult(payload) {
	// 엔지니어 체크리스트 저장
	return new Promise((resolve, reject) => {
		axios
			.post('/v1/saveEngCheckVanResult', payload, {
				headers: { authorization: store.state.token.access_token },
			})
			.then((res) => {
				if (res.data?.success) {
					resolve(res.data);
				} else {
					reject(res.data || res.response?.data || res);
				}
			})
			.catch((error) => {
				reject(error.response?.data || error);
			});
	});
}

export function sendSignup(payload) {
	// 회원가입 정보를 전송함
	return new Promise((resolve, reject) => {
		postData(
			'/signup',
			payload,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function saveUser(payload) {
	// 마이페이지 수정 정보 전송함
	return new Promise((resolve, reject) => {
		postData(
			'/saveUser',
			payload,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function requestLogin(payload) {
	// 로그인 요청
	return new Promise((resolve, reject) => {
		postData(
			'/signin',
			payload,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail);
			},
		);
	});
}

export function requestLogout() {
	// 로그아웃 요청
	return new Promise((resolve, reject) => {
		postData(
			'/logout',
			{},
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function getCertification(params) {
	// 비밀번호 찾기 - 인증번호 전송
	return new Promise((resolve, reject) => {
		fetchData(
			'/getCertification',
			params,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function getCertificationCk(params) {
	// 비밀번호 찾기 - 인증번호 확인
	return new Promise((resolve, reject) => {
		fetchData(
			'/getCertificationCk',
			params,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function getEngineerPwChange(params) {
	// 비밀번호 찾기 - 비밀번호 변경
	return new Promise((resolve, reject) => {
		fetchData(
			'/getEngineerPwChange',
			params,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}

export function getPolicyInfo(params) {
	// 비밀번호 찾기 - 비밀번호 변경
	return new Promise((resolve, reject) => {
		fetchData(
			'/getPolicyInfo',
			params,
			(res) => {
				resolve(res);
			},
			(fail) => {
				reject(fail.message);
			},
		);
	});
}
